module.exports = __webpack_public_path__ + "static/media/Azure DevOps.812bd1a7.svg";